import React from 'react';
import { Button } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';

/**
 * The filter row above a list. Fields wrap on narrow screens; Reset and any
 * extra actions stay pinned to the right.
 *
 *   <FilterBar onReset={reset} resetDisabled={!dirty} actions={<Button>Export</Button>}>
 *     <FilterBar.Item width={260}><Input.Search .../></FilterBar.Item>
 *     <FilterBar.Item label="Status"><Select .../></FilterBar.Item>
 *   </FilterBar>
 */
const FilterBar = ({ children, actions, onReset, resetDisabled = false, footer }) => (
  <div className="filter-bar">
    <div className="filter-bar__row">
      <div className="filter-bar__fields">{children}</div>
      {onReset || actions ? (
        <div className="filter-bar__actions">
          {onReset ? (
            <Button icon={<ReloadOutlined />} onClick={onReset} disabled={resetDisabled}>
              Reset
            </Button>
          ) : null}
          {actions}
        </div>
      ) : null}
    </div>
    {footer ? <div className="filter-bar__footer">{footer}</div> : null}
  </div>
);

const FilterItem = ({ label, width, grow = false, children }) => (
  <div
    className="filter-bar__item"
    style={{ width: width || undefined, flex: grow ? '1 1 220px' : undefined }}
  >
    {label ? <span className="filter-bar__label">{label}</span> : null}
    {children}
  </div>
);

FilterBar.Item = FilterItem;

export default FilterBar;
